import pathfinder from '@fiverr-private/pathfinder';
import { PATHFINDER } from '../../constants';

export const getSearchQueryPath = ({ query }, source) => {
    const options = { query: { query, source } };
    return pathfinder(PATHFINDER.SEARCH, {}, options);
};
